/**
 * 公共请求方法
 * Filename: request.js
 * Author: GaoYu
 * Time: 2020/6/10 9:33
 */
import axios from 'axios'
import auth from './auth'

const service = axios.create({
  baseURL: process.env.API_EE_BASE_URL,
  timeout: 5000
})

service.defaults.withCredentials = true

// 添加请求拦截器
service.interceptors.request.use(config => {
  if (config.url.indexOf(process.env.API_DY_BASE_URL) !== -1) {
    config.headers['access-token'] = auth.getToken()
    config.headers['client-type'] = auth.getClientType()
    config.headers['sign'] = auth.getReqSign()
  }
  return config
}, (error) => {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(response => {
  const res = response.data
  return res
}, error => {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js